import { Button, Grid2 } from "@mui/material";
import React from "react";
import SurpriceBackground from "Assets/Backgrounds/surprise-background.png";
import SurpriceIcon from "Assets/Icons/Home/SurpriceIcon.svg";

const styles = (theme) => ({
  borderRadius: "8px",
  padding: "10px",
  backgroundImage: `url(${SurpriceBackground})`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& button": {
    position: "absolute",
    opacity: "0.8",
  },
});

const Surprice = () => {
  return (
    <Grid2 sx={styles}>
      <img src={SurpriceIcon} alt="" />
      <Button variant="contained" color="white">
        Click to Reveal
      </Button>
    </Grid2>
  );
};

export default Surprice;
